export const SettingCopyrightModule = () => {
  return (
    <div className="w-full p-[20px]">
      <p className="whitespace-pre-wrap text-left text-[13px] leading-[20px] text-[#00000040]">
        {
          "2024 FANDOMDAO LIMITED. All righted reserved.\nFANDOMDAO LIMITED | 202403812D\n190 WOODLANDS INDUSTRIAL PARK E5\n#08-13, WOODLANDS BIZHUB\nSINGAPORE (757516)\nFANDOMDAO LIMITED\n+61 0436474856"
        }
      </p>
    </div>
  );
};
